<template>
  <div class="mall-fixed-bar">
    <div class="mall-fixed-bar__bd">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MallFixedBar'
};
</script>

<style lang="scss">
.mall-fixed-bar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;

  .mall-fixed-bar__bd {
    max-width: 10rem;
    height: 100%;
    margin: 0 auto;

    &:after {
      display: block;
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
      content: "";
    }
  }
}
</style>
